export const MANAGER_NAV_ITEMS = [
  { key: "analytics", label: "Analytics", icon: "📊" },
  { key: "customers", label: "Customers", icon: "👥" },
  { key: "hall-rentals", label: "Hall Rentals", icon: "🏛" },
  { key: "deleted-orders", label: "Cancelled Orders", icon: "🗑" },
  { key: "expenses", label: "Expenses", icon: "💰" },
];
